import React, { useEffect, useState } from 'react';
import './Display.css';
import api from '../api';


const Display = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.list('items')
      .then((data) => {
        setItems(data || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || '加载失败');
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="display-loading">加载中...</div>;
  if (error) return <div className="display-error">{error}</div>;

  return (
    <div className="display-container">
      <h2 className="display-title">商品信息</h2>
      <div className="display-grid">
        {items.map((item) => (
          <div className="display-card" key={item.id}>
            <img
              className="display-image"
              src={item.image || '../images/001.jpg'}
              alt={item.name}
            />
            <div className="display-info">
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              <div className="display-price">￥{item.price}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Display;
